/* RBC Recently viewed (V18)
   Records each product you open (in the browser), then shows them back as a
   slider on the product page. Excludes the product you're currently viewing. */
(function () {
  'use strict';
  var KEY = 'rbc_recent';
  var MAX = 12;
  var sec = document.getElementById('recentlyViewed');
  var current = sec ? sec.getAttribute('data-current') : '';

  function read() {
    try { var v = JSON.parse(localStorage.getItem(KEY) || '[]'); return Array.isArray(v) ? v : []; }
    catch (e) { return []; }
  }
  function write(l) { try { localStorage.setItem(KEY, JSON.stringify(l.slice(0, MAX))); } catch (e) {} }

  function money(c) { return '₦' + (c / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }

  function card(p) {
    var img = p.featured_image || (p.images && p.images[0]);
    var media = img
      ? '<img class="media__img" src="' + img + '&width=600" alt="' + (p.title || '').replace(/"/g, '&quot;') + '" loading="lazy" width="600" height="750">'
      : '<span class="media__tag media__tag--soft">rbc</span>';
    var price = p.compare_at_price && p.compare_at_price > p.price
      ? '<span class="price__sale">' + money(p.price) + '</span> <s class="price__compare">' + money(p.compare_at_price) + '</s>'
      : money(p.price);
    return '' +
      '<div class="rec-slide" role="listitem">' +
        '<article class="product-card">' +
          '<div class="product-card__media">' +
            '<a class="product-card__media-link" href="/products/' + p.handle + '" tabindex="-1" aria-hidden="true">' +
              '<div class="product-card__media-scale"><div class="media media--portrait media--studio">' + media + '</div></div>' +
            '</a>' +
            '<button class="wish-btn" type="button" data-wish="' + p.handle + '" aria-pressed="false" aria-label="Save this piece">' +
              '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true"><path d="M12 21C12 21 3.5 15.4 3.5 9.5 3.5 6.9 5.6 4.8 8.2 4.8c1.6 0 3 .8 3.8 2 .8-1.2 2.2-2 3.8-2 2.6 0 4.7 2.1 4.7 4.7C20.5 15.4 12 21 12 21Z"/></svg>' +
            '</button>' +
          '</div>' +
          '<a class="product-card__name-link" href="/products/' + p.handle + '"><h3 class="product-card__name">' + p.title + '</h3></a>' +
          '<p class="product-card__price">' + price + '</p>' +
        '</article>' +
      '</div>';
  }

  /* Build the list from what was viewed before this page. */
  if (sec) {
    var track = sec.querySelector('[data-recent-track]');
    var list = read().filter(function (h) { return h && h !== current; });
    if (!list.length) {
      sec.setAttribute('hidden', '');
    } else {
      Promise.all(list.slice(0, MAX).map(function (h) {
        return fetch('/products/' + h + '.js', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
      })).then(function (products) {
        var good = products.filter(Boolean);
        if (!good.length) { sec.setAttribute('hidden', ''); return; }
        track.innerHTML = good.map(card).join('');
        sec.removeAttribute('hidden');
        if (window.RBCWishlist && window.RBCWishlist.sync) window.RBCWishlist.sync();
      });
    }
  }

  /* Record the current product last, so it shows up next time — not on its own page. */
  if (current) {
    var updated = read().filter(function (h) { return h !== current; });
    updated.unshift(current);
    write(updated);
  }
})();
